export const LOAD_COUNTER_CONFIG = "LOAD_COUNTER_CONFIG";
export const LOAD_COUNTERS_CONFIG = "LOAD_COUNTERS_CONFIG";
export const CREATE_COUNTER_CONFIG = "CREATE_COUNTER_CONFIG";
export const UPDATE_COUNTER_CONFIG = "UPDATE_COUNTER_CONFIG";
export const DELETE_COUNTER_CONFIG = "DELETE_COUNTER_CONFIG";
export const SET_BASE_PRICE_INFO_BLOCK = "SET_BASE_PRICE_INFO_BLOCK";
export const SET_SHOW_VIDEO_GUIDE = "SET_SHOW_VIDEO_GUIDE";
